import { Formik, Form } from 'formik';

import { toast } from '@hivebrite/design-system/Toast';

import { MentoringFormContent } from 'hb-react/frontoffice/apps/Mentoring/components/MentoringFormContent';
import {
  type CustomAttributeType,
  type MentoringCreateFormikValues,
  type MentoringProfile,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { customAttributesInitialValues } from 'hb-react/shared/components/formik/utils/customAttributes';
import { type CustomAttributeFormValue } from 'hb-react/types';

interface MentoringReapplyFormProps {
  applicationDescription: string;
  attributes: Array<CustomAttributeType>;
  mentoringProfile: MentoringProfile & { status: 'rejected_can_reapply' };
  onReapply: (payload: {
    [s: string]: CustomAttributeFormValue;
  }) => Promise<MentoringProfile>;
  onSuccess: () => void;
  title: string;
}

export const MentoringReapplyForm = ({
  applicationDescription,
  attributes,
  mentoringProfile,
  onReapply,
  onSuccess,
  title,
}: MentoringReapplyFormProps) => {
  const onSubmit = async (values: MentoringCreateFormikValues) => {
    try {
      await onReapply({ ...values, status: 'pending' });
      toast.success(s__('Mentoring|Your request has been submitted'));
      onSuccess();
      // eslint-disable-next-line no-empty
    } catch {}
  };

  const initialValues =
    attributes.length > 0
      ? {
          ...customAttributesInitialValues(
            mentoringProfile.custom_attributes_form,
          ),
        }
      : {};

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      enableReinitialize
    >
      <Form>
        <MentoringFormContent
          applicationDescription={applicationDescription}
          attributes={attributes}
          title={title}
        />
      </Form>
    </Formik>
  );
};
